import React from 'react'
import './Navigation.scss'

interface NavigationProps {
  navigationOpen: boolean
}

export default function Navigation({ navigationOpen }: NavigationProps) {
  return (
    <div className={`navigation ${navigationOpen && 'navigation__open'}`}>
      <div className='navigation__links'>
        <a href='https://github.com/williamsimms' target='_blank' rel='noopener noreferrer'>
          Github
        </a>
        <a href='https://twitter.com/wijlum' target='_blank' rel='noopener noreferrer'>
          Twitter
        </a>
        <a href='mailto:williamsimms193@gmail.com' target='_blank' rel='noopener noreferrer'>
          Email
        </a>
        <a href='https://www.instagram.com/wijlum/?hl=en' target='_blank' rel='noopener noreferrer'>
          Instagram
        </a>
      </div>
    </div>
  )
}
